export default "__VITE_ASSET__DoqVuZwP__"